import { post } from "../services/HttpService";
import moment from 'moment';
import { accountNumberValidationRegex, emailValidationRegex, ifscValidationRegex,
    beneficiaryNameRegex, phoneNumberValidationRegex, upiHandleValidationRegex,
    panNumberValidationRegex,gstNumberValidationRegex,
    cinNumberValidationRegex,
    businessModelValidationRegex 
} from "../app_methods";
import { beneficiaryOrganisationTypes as organisationTypes } from "../constants";


export class QuickTransfer {
    constructor(quickTransferObject = {}) {
        this.set(quickTransferObject);
    };

    static validations = {
        "beneficiary_type": [],
        "unique_request_number": [
            { required: true, message: "Unique Request Number is required." },
            { pattern: '^[A-Za-z0-9_ ]+$', message: "Please enter a valid unique request number." },
            { min: 4, message: "Must be atleast 4 characters long" },
            { max: 35, message: "Can be of maximum 35 characters" }
        ],
        "custom_unique_request_number": [
            { required: true, message: "Unique Request Number is required." },
            { pattern: '^[A-Za-z0-9_]+$', message: "Please enter a valid unique request number." },
            { min: 1, message: "Must be atleast 1 characters long" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "beneficiary_name": [
            { required: true, message: "Beneficiary is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 250, message: "Can be of maximum 250 characters" }
        ],
        "account_number": [
            { required: true, message: "Account Number is required." },
            { pattern: accountNumberValidationRegex(), message: "Please enter a valid account number." },
            { min: 3, message: "Must be atleast 3 characters long" },
            { max: 26, message: "Maximum 26 characters allowed" }
        ],
        "ifsc": [
            { required: true, message: "IFSC Code is required." },
            { pattern: ifscValidationRegex(), message: "Please enter a valid IFSC." },
            { len:11, message: "IFSC must be of 11 characters." }
        ],
        "upi_handle": [
            { required: true, message: "UPI Handle is required." },
            { pattern: upiHandleValidationRegex(), message: "UPI Handle is invalid." }
        ],
        "payment_mode": [
            { required: true, message: "Payment Mode is required." }
        ],
        "amount": [
            { required: true, message: "Amount is required." },
            { pattern: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$', message: "Please enter a valid amount." }
        ],
        "narration": [
            { min: 2, message: "Narration must be atleast 2 characters long."},
            { max: 255 , message: "Narration must be of 255 characters"}
        ],
        "email": [
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." },
            { minLength: 1, message: "Must be atlest 1 characters long" },
            { maxLength: 150, message: "Can be of maximum 100 characters" }
        ],
        "phone": [
            { pattern: phoneNumberValidationRegex(), message: "Please enter a valid phone number." }
        ],
        "amazon_wallet": [
            { pattern: phoneNumberValidationRegex(), message: "Please enter a valid phone number." }
        ],
        "udf1": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf2": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf3": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf4": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf5": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "virtual_account_number": [
            { required: true, message: "Source Account is required." }
        ],
        "scheduled_for": [],
        "beneficiary_user_id": [{ required: true, message: "User id is required." }],
        "pan_number": [
            { required: true, message: "PAN Number is required." },
            { pattern: panNumberValidationRegex(), message: "Please enter a valid PAN Number." },
        ],
        "beneficiary_lei": [
            { pattern: /^[A-Z0-9]{18}[0-9]{2}$/, message: "Please enter a valid LEI (20 characters)." },
            { min: 20, message: "LEI must be exactly 20 characters long" },
            { max: 20, message: "LEI must be exactly 20 characters long" },
            { required: true, message: "Beneficiary LEI is required." }
        ],
        "cin_number": [
            { pattern: cinNumberValidationRegex(), message: "CIN Number is invalid"}
        ],
        "gst_number": [
            { pattern: gstNumberValidationRegex(), message: "GST Number is invalid"}
        ],
        "organisation_type": [
            { required: true, message: "Organisation Type is required." },
            {
                validator: (_, value) =>{
                    const isValid = organisationTypes.some(type => type.value === value);
                    return !value || isValid
                    ? Promise.resolve()
                    : Promise.reject("Invalid Organisation Type");
                }
            }
        ],
        "business_model": [
            { required: true, message: "Business Model is required." },
            { pattern: businessModelValidationRegex(), message: "Business Model is invalid"},
            { max: 50, message: "Maximum 50 characters allowed" }
        ]
    };

    /**
     * @memberof QuickTransfer
     * @type API
     * @returns Promise
     */
    validate = () => {
        const queryData = this.get();
        if (queryData.scheduled_for) queryData.scheduled_for = moment(queryData.scheduled_for).format("YYYY-MM-DD");
        // if (queryData.account_number && queryData.account_number.startsWith("EASEBZ")) return Object.create({ success: false, data: { message: "Invalid Account Number." } });
        return post(`v1/internal/quick_transfers/validate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof QuickTransfer
     * @type API
     * @returns Promise
     */
    initiate = (queryData = {}) => {
        queryData = { ...queryData, ...this.get() };
        if (queryData.scheduled_for) queryData.scheduled_for = moment(queryData.scheduled_for).format("YYYY-MM-DD");
        return post(`v1/internal/quick_transfers/initiate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof QuickTransfer
     * @type Getter Method
     * @returns QuickTransfer
     */
    get = () => {
        return {
            beneficiary_type: this.beneficiary_type,
            unique_request_number: this.unique_request_number,
            beneficiary_name: this.beneficiary_name,
            account_number: this.account_number,
            ifsc: this.ifsc,
            upi_handle: this.upi_handle,
            payment_mode: this.payment_mode,
            amount: this.amount,
            narration: this.narration,
            queue_on_low_balance: this.queue_on_low_balance,
            email: this.email,
            phone: this.phone,
            udf1: this.udf1,
            udf2: this.udf2,
            udf3: this.udf3,
            udf4: this.udf4,
            udf5: this.udf5,
            virtual_account_number: this.virtual_account_number,
            scheduled_for: this.scheduled_for,
            otp_details: this.otp_details,
            beneficiary_user_id: this.beneficiary_user_id,
            pan_number: this.pan_number,
            beneficiary_lei: this.beneficiary_lei,
            cin_number: this.cin_number,
            gst_number: this.gst_number,
            organisation_type: this.organisation_type,
            business_model: this.business_model,
        }
    };

    /**
     * @memberof QuickTransfer
     * @type Setter Method
     * @takes QuickTransfer Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof QuickTransfer
     * @type Setter Method
     * @takes QuickTransfer Params
     * @returns void
     */
    reset = () => {
        this.beneficiary_type = undefined;
        this.unique_request_number = undefined;
        this.beneficiary_name = undefined;
        this.account_number = undefined;
        this.ifsc = undefined;
        this.upi_handle = undefined;
        this.payment_mode = undefined;
        this.amount = undefined;
        this.narration = undefined;
        this.queue_on_low_balance = undefined;
        this.email = undefined;
        this.phone = undefined;
        this.udf1 = undefined;
        this.udf2 = undefined;
        this.udf3 = undefined;
        this.udf4 = undefined;
        this.udf5 = undefined;
        this.virtual_account_number = undefined;
        this.scheduled_for = undefined;
        this.otp_details = undefined;
        this.beneficiary_user_id = undefined;
        this.pan_number = undefined;
        this.beneficiary_lei = undefined;
        this.cin_number = undefined;
        this.gst_number = undefined;
        this.organisation_type = undefined;
        this.business_model = undefined;
    };
}